// global initializer
import global from './global';

// utilities
import utils from './utils';

// prevent error on global script using condition like `if ($) {...}`
if (typeof window.$ === 'undefined') {
  window.$ = false;
}

// must run first in sync
global.setup();

// main initialization
(async ($, /* eslint-disable */ window, undefined /* eslint-enable */) => {
  $(function() {
    // invoke global initialization
    global.init();

    // invoke all components initialization
    const context = window.document;
    utils.component.invoke(context);
  });
})(jQuery, window);